module.exports = __webpack_public_path__ + "static/img/1.f6aedad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/eng/1.png
// module id = MzV7
// module chunks = 0